import { printMoney, escapeString } from './../../process/pc-slate-tools';

export const generatePricing = (price, compare_price, clazz, p) => {
  clazz = clazz || "";

  let hasComparePrice = '';
  // if (compare_price > price) {
  //   return hasComparePrice += 'has-compare-price';
  // }

  let x = `<div class='o-product-pricing ${clazz}'>`;
  if (compare_price > price){
    x += `
    <div
      class="o-product-pricing__money o-product-pricing__price ${clazz}-money ${clazz}-price is-compare-price"
      data-money="${compare_price}" data-product-compare-price
    >
      ${printMoney(compare_price)}
    </div>
  `;
  }
  if(price == 0) {
    x += `
      <span
        class="o-product-pricing__money o-product-pricing__price ${clazz}-money ${clazz}-price "
        data-currency data-product-money
      >
        ${escapeString(Language.strings['products.layout.free'])}
      </span>
    `;
  } else {
    x += `
      <span
        class="o-product-pricing__money o-product-pricing__price ${clazz}-money ${clazz}-price"
        data-currency data-money="${price}" data-product-money
      >
        <span class="money" data-product-id="${p.id}">${printMoney(price)}</span>
      </span>
    `;
  }

  // if (compare_price > price){
  //   let saving = compare_price - price;
  //   x += `
  //   <div
  //     class="o-product-pricing__money o-product-pricing__compare ${clazz}-money ${clazz}-compare"
  //     data-currency data-money="${saving}" data-product-compare-money
  //   >
  //     ${escapeString(Language.strings['products.layout.save'])}
  //     <span data-product-save-money  data-currency data-money="${saving}">${printMoney(saving)}</span>
  //   </div>
  //   `;
  // } else {
  //   x += `
  //   <div class="{{ o-product-pricing__money o-product-pricing__compare ${clazz}-money ${clazz}-compare }}" data-currency data-product-compare-money>
  //   </div>
  //   `;
  // }

  x += '</div>';
  return x;
}
